// src/pages/EBIGeneration.js this is with DILI stuff and iframe 
import React, { useContext, useState, useEffect, useRef } from 'react';
import { UserContext } from '../context/UserContext';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Container, Typography, Button, Card, CardContent, CircularProgress } from '@mui/material';
import { motion } from 'framer-motion';
import ProgressContext from '../context/ProgressContext';
import HorizontalStepper from '../components/HorizontalStepper';
import BackButton from '../components/BackButton';
import DOMPurify from 'dompurify';
import apiClient from '../utils/apiClient';
import { Modal, IconButton, TextField } from '@mui/material';
import ThumbDownAltOutlined from '@mui/icons-material/ThumbDownAltOutlined'
import ThumbUpAltOutlined from '@mui/icons-material/ThumbUpAltOutlined'

// === AES Encryption in JavaScript with CryptoJS ===
import CryptoJS from 'crypto-js';
import { ThumbDownAlt, ThumbUpAlt } from '@mui/icons-material';
// REPLACE with your real clientId used for encryption:
const CLIENT_ID = process.env.REACT_APP_LOGINASSISTANT_HASH;
// EXACT encryption logic you provided:
function encryptAES(plainText) {
  const key = CryptoJS.enc.Utf8.parse(CLIENT_ID);
  // Last 16 characters for IV
  const ivString = CLIENT_ID.slice(-16);
  const iv = CryptoJS.enc.Utf8.parse(ivString);
  const encrypted = CryptoJS.AES.encrypt(
    CryptoJS.enc.Utf8.parse(plainText),
    key,
    {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }
  );
  return encrypted.toString(); // Base64
}
export default function EBIGeneration() {
  const {
    pitchResponse,
    selectedProducts,
    selectedProductCodes,
    productRecommendationFormData,
    ebiLLMOutputs,
    setEbiLLMOutputs,
  } = useContext(UserContext);
  const { steps, currentStep, nextStep, setCurrentStep } = useContext(ProgressContext);
  const { setUserNTID, setUserChannel, userNTID } = useContext(UserContext);
  const navigate = useNavigate();
  // We'll store the "uniqueVal" in localStorage so each user sees the same uniqueVal across reloads
  // This is your session-tracking ID that you pass to the external iFrame.
  const [uniqueVal, setUniqueVal] = useState('');
  // We'll store the explanations we poll from the backend here.
  // Keyed by productCode: { [productCode]: "some explanation" }
  const [explanations, setExplanations] = useState({});
  // Whether we are still waiting for the explanation or not
  // We'll track per productCode or do a single spinner if you prefer. 
  const [loadingStates, setLoadingStates] = useState({});
  // Polling intervals
  const pollingIntervalRef = useRef(null);
  const [productUniqueMapping, setProductUniqueMapping] = useState({})
  const initialTimeoutRef = useRef(null);

  const [modalOpen, setModalOpen] = useState(true)
  const handleOpen = () => setModalOpen(true)
  const handleClose = () => setModalOpen(false)
  const [iframeLoadingStates, setIframeLoadingStates] = useState({})
  const [feedback_open, setFeedback_open] = useState(0)
  const [feedback_liked, setFeedback_licked] = useState(false)
  const [feedback_disliked, setFeedback_dislicked] = useState(false)
  const [feedback_value, feedback_value_set] = useState('')

  const dislikeFeedback = async () =>{
    if (!feedback_liked && !feedback_disliked) {
      setFeedback_open(1)
    }
  }
  const likeFeedback = async () => {
    if (!feedback_liked && !feedback_disliked) {
      const response = await apiClient.post('/feedback', {
        "session_id": userNTID,
        "query": "EBI Generation",
        "response": "",
        "feedback": "thumbs_up",
        "product": "",
        "ntID": userNTID

      }, { withCredentials: true });

      setFeedback_licked(true)
    }

  }
  const submitFeedback = async () => {
    if (!feedback_disliked) {
      const response = await apiClient.post('/feedback', {
        "session_id": userNTID,
        "query": "EBI Generation",
        "response": feedback_value,
        "feedback": "thumbs_down",
        "product": "",
        "ntID": userNTID
      }, { withCredentials: true });
      FeedbackPopupClose()
      setFeedback_dislicked(true)
    }

  }

  const getUniqueValFromProduct = (product_id) => {
    if (productUniqueMapping[product_id]) {
      return productUniqueMapping[product_id]
    }
    const newUniqueValue = Math.floor(Math.random() * 900000 + 100000).toString();

    setProductUniqueMapping(prevMapping => ({
      ...prevMapping,
      [product_id]: newUniqueValue
    }))
    return newUniqueValue
  }
  useEffect(() => {
    // 1) On mount, ensure we have a uniqueVal in local storage
    let storedVal = localStorage.getItem('myUniqueVal');
    if (!storedVal) {
      // If none, generate a random 6-digit or so ID
      const randomVal = Math.floor(Math.random() * 900000 + 100000).toString();
      localStorage.setItem('myUniqueVal', randomVal);
      storedVal = randomVal;
    }
    setUniqueVal(storedVal);
  }, []);
  // 2) On step mount, set the step index:
  useEffect(() => {
    const stepIndex = steps.findIndex((step) => step.path === '/dashboard/ebi-generation');
    if (stepIndex !== -1) {
      setCurrentStep(stepIndex);
    }
  }, [steps, setCurrentStep]);
  useEffect(() => {
    const handlePopState = () => window.history.pushState(null, "", window.location.href);
    window.history.pushState(null, "", window.location.href);
    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, []);

  // 3) Build the iFrame URL with encryption:
  const buildIframeUrl = (productCode) => {
    // The external system wants "DILI" + <uniqueVal> as the raw session_id
    const rawSessionId = 'DILI' + getUniqueValFromProduct(productCode); // e.g. DILI123456
    console.log("rawSessionid ==== ", rawSessionId)
    const encrypted = encryptAES(rawSessionId);
    // Example iFrame URL:
    // http://buyuat.iprulifeinsurance.com/digiuatnew/EBI.htm#/LAEBI/<productCode>?value=<encrypted>
    const baseUrl = 'https://buyuat.iprulifeinsurance.com/digiuatnew/EBI.htm#/LAEBI';
    // const baseUrl="http://localhost:3000"
    return `${baseUrl}/${productCode}?value=${encodeURIComponent(encrypted)}`;
    // return baseUrl
  };
  // 4) Optional: Call your LLM-based fill_inputs_with_genai
  const handleFillWithGenAI = async (productCode, productName) => {
    try {
      const functionDef = `
        /* Fields for ${productName} etc. Provide your instructions */
        Premium, CoverageTerm, ...
      `;
      const response = await apiClient.post('/fill-inputs/genai', {
        product_code: productCode,
        product_name: productName,
        customer_profile: {
          name: productRecommendationFormData.customerName,
          age: productRecommendationFormData.customerAge,
          gender: productRecommendationFormData.gender,
          ntID: userNTID
          // ... anything else you like
        },
        function_def: functionDef,
      });
      setEbiLLMOutputs((prev) => ({
        ...prev,
        [productCode]: response.data.suggestion,
      }));
    } catch (error) {
      console.error('Error calling fill_inputs_with_genai:', error);
    }
  };
  // 5) Poll the backend to see if the explanation is available
  const pollExplanations = async (productCode) => {
    try {
      // For each product code, check if we already have an explanation or not
      if (!explanations[productCode]) {
        // Mark loading as false for this product
        setLoadingStates((prev) => ({
          ...prev,
          [productCode]: 1,
        }));
        // We only poll if we haven't found an explanation yet
        const res = await apiClient.post('/poll_explanation',
          {
            ntID: userNTID,
            user_id: userNTID,
            uniqueVal: getUniqueValFromProduct(productCode),
            productCode: productCode
          },
          {
            // params: { uniqueVal: uniqueVal, productCode: productCode },
            withCredentials: true,
          }
        );
        if (res.data && res.data.explanation_found) {
          const newExp = res.data.explanation || '';
          setExplanations((prev) => ({
            ...prev,
            [productCode]: newExp,
          }));
          // Mark loading as false for this product
          setLoadingStates((prev) => ({
            ...prev,
            [productCode]: 2,
          }));
        }

      }
    } catch (err) {
      console.error('Error polling explanation:', err);
      setLoadingStates((prev) => ({
        ...prev,
        [productCode]: 3,
      }));

    }
  };

  let iframeLoadingStatesVariable = {}
  selectedProductCodes.forEach((pc) => {
      if(Object.keys(iframeLoadingStatesVariable).length==0){
        iframeLoadingStatesVariable[pc]=1
      }else{
        iframeLoadingStatesVariable[pc]=0

      }
    });
    
    const LoadNextIframe=(index)=>{
      console.log("loading...",index)
      if(index <selectedProductCodes.length ){
      let target_code = selectedProductCodes[index+1]
      console.log("target_code...", target_code)
      setIframeLoadingStates((prev)=>({
        ...prev,
        [target_code]:1
      }))
      }
    }

  // 6) Start polling after 1 minute, then every 10 seconds
  useEffect(() => {
    // Clear any existing intervals
    if (pollingIntervalRef.current) {
      clearInterval(pollingIntervalRef.current);
    }
    if (initialTimeoutRef.current) {
      clearTimeout(initialTimeoutRef.current);
    }
    // Start with loading = true for all productCodes
    const initialLoadingStates = {};
    selectedProductCodes.forEach((pc) => {
      initialLoadingStates[pc] = 0;
    });
    setIframeLoadingStates(iframeLoadingStatesVariable)
    setLoadingStates(initialLoadingStates);
    // Wait 10 minute, then start polling every 100s... remove one zero for real implementation
    // initialTimeoutRef.current = setTimeout(() => {
    //   pollExplanations(); // first check
    //   pollingIntervalRef.current = setInterval(pollExplanations, 10_0000); // then every 100s
    // }, 10_000);
    // Cleanup
    return () => {
      // if (pollingIntervalRef.current) {
      //   clearInterval(pollingIntervalRef.current);
      // }
      // if (initialTimeoutRef.current) {
      //   clearTimeout(initialTimeoutRef.current);
      // }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uniqueVal, selectedProductCodes]);
  // 7) Next Step
  const FeedbackPopupClose = () => {
    setFeedback_open(0)
  }

  const handleNext = () => {
    nextStep();
    if(selectedProductCodes>1){
      navigate('/dashboard/product-comparison');
    }else{
      navigate('/dashboard/summary-creation');
    }
  };
  const nextStepLabel = selectedProductCodes.length >1 ? 'Next to Product Comparison': 'Next to Summary Creation';
  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Modal
        open={feedback_open}
        onClose={() => { setFeedback_open(0) }}
      >
        <div style={{ margin: '250px' }}>
          <div style={{ padding: '20px', backgroundColor: 'white', overflowY: 'scroll', height: '250px', width: '100%', marginLeft: '0' }}>
            <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
              <h4>Please provide your feedback and opinion. </h4>
            </Typography>
            <TextField minRows={3} sx={{ width: '100%', 'marginBottom': '5' }} placeholder='Tell us your feedback' value={feedback_value} onChange={(e) => { feedback_value_set(e.target.value) }} />

            <Button variant="contained" color="primary" sx={{ float: 'right', marginTop: '15px' }} onClick={submitFeedback}>Submit</Button>
            <Button variant="outlined" color="primary" sx={{ float: 'right', marginTop: '15px', marginRight: '15px' }} onClick={FeedbackPopupClose}>Close</Button>


          </div>
        </div>

      </Modal>

      <Modal open={modalOpen} onClose={handleClose}>
        <div style={{ margin: '100px' }}>
          <div style={{ padding: '20px', backgroundColor: 'white', overflowY: 'scroll', height: '600px' }}>
            <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
              <h2>Pitch we are giving:
                <Button variant="contained" color="primary" sx={{ float: 'right' }} onClick={handleClose}>Close</Button></h2>

            </Typography>
            <Typography
              sx={{ marginBottom: '60px' }}
              component="div"
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(pitchResponse) }}
            />


            <div sx={{ padding: '10px', width: '100%', marginTop: '20px', marginBottom: '60px' }}>
              <IconButton onClick={() => { likeFeedback() }}>
                {!feedback_liked ? (
                  <ThumbUpAltOutlined sx={{ color: "rgb(112 48 160)" }} />
                ) : (
                  <ThumbUpAlt sx={{ color: "rgb(112 48 160)" }} />
                )}
              </IconButton>
              <IconButton onClick={() => { dislikeFeedback() }}>
                {!feedback_disliked ? (
                  <ThumbDownAltOutlined sx={{ color: "rgb(112 48 160)" }} />
                ) : (
                  <ThumbDownAlt sx={{ color: "rgb(112 48 160)" }} />
                )}
              </IconButton>
              <Button variant="contained" color="primary" sx={{ width: '20%', float: 'right', }} onClick={handleClose}>Close</Button>
            </div>

          </div>
        </div>
      </Modal>
      <HorizontalStepper />
      <BackButton />
      <motion.div
        initial={{ opacity: 0, x: -50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.5 }}
      >
        <div class="container">
          <Typography variant="h5" gutterBottom sx={{ mt: 4, mb: 4 }}>
            EBI Generation
          </Typography>
          <Button variant='contained' onClick={handleOpen}>Open Customer Pitch</Button>
        </div>
        <Card
          sx={{
            mt: 2,
            backgroundColor: 'rgba(255, 255, 255, 0.7)',
            backdropFilter: 'blur(10px)',
            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
            borderRadius: 2,
          }}
        >
          <CardContent>
            {/* For each selected product, show LLM "fill form" and iFrame */}

            {selectedProductCodes.map((productCode, idx) => {
              const productName = selectedProducts[idx];
              const llmSuggestion = ebiLLMOutputs[productCode] || '';
              const explanation = explanations[productCode] || '';
              const isLoading = loadingStates[productCode] || false;
              return (
                <Card
                  key={productCode}
                  sx={{
                    mt: 4,
                    backgroundColor: 'rgba(255, 255, 255, 0.7)',
                    backdropFilter: 'blur(10px)',
                    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
                    borderRadius: 2,
                  }}
                >
                  <CardContent>
                    <Typography variant="h6">
                      Product: {productName} (Code: {productCode})
                    </Typography>
                    {/* 4a) Button to fill disclaimers or inputs with GenAI (OPTIONAL) */}
                    {llmSuggestion && (
                      <div style={{ marginTop: '20px' }}>
                        <Typography variant="subtitle1" sx={{ mb: 1 }}>
                          LLM Suggestion/Explanation:
                        </Typography>
                        <div
                          style={{
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            padding: '10px',
                            maxHeight: '200px',
                            overflowY: 'auto',
                            backgroundColor: '#f5f5f5'
                          }}
                          dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(llmSuggestion),
                          }}
                        />
                      </div>
                    )}
                    {/* 5) The iFrame pointing to the external system */}
                    <Typography variant="subtitle1" sx={{ mt: 2 }}>
                      External EBI Form
                    </Typography>
                    {iframeLoadingStates[productCode] ==1 ? (
                    <iframe
                      title={`EBI Form - ${productName}`}
                      src={buildIframeUrl(productCode)}
                      style={{ width: '100%', height: '600px', border: '1px solid #ccc' }}
                      onLoad={()=>{LoadNextIframe(idx)}}
                    />):(<>loading...</>)}
                    {/* 6) Explanation from the LLM (if found) */}
                    <Button variant="contained" onClick={() => { pollExplanations(productCode) }}>Generate Explaination</Button>
                    {isLoading == 1 ? (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <CircularProgress size={20} />
                        <Typography variant="body2">Waiting for EBI Explanation...</Typography>
                      </div>
                    ) : (<></>)}
                    {isLoading == 3 ? (
                      <><Typography variant="subtitle1" sx={{ mt: 2 }}>
                        Explaination is not ready yet:
                      </Typography></>) : (<></>)}

                    {isLoading == 2 ? (
                      <><Typography variant="subtitle1" sx={{ mt: 2 }}>
                        Explanation from LLM:
                      </Typography>

                        <div
                          style={{
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            padding: '10px',
                            backgroundColor: '#fafafa'
                          }}
                          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(explanation) }}
                        />
                        <IconButton onClick={() => { likeFeedback() }}>
                          {!feedback_liked ? (
                            <ThumbUpAltOutlined sx={{ color: "rgb(112 48 160)" }} />
                          ) : (
                            <ThumbUpAlt sx={{ color: "rgb(112 48 160)" }} />
                          )}
                        </IconButton>
                        <IconButton onClick={() => { dislikeFeedback() }}>
                          {!feedback_disliked ? (
                            <ThumbDownAltOutlined sx={{ color: "rgb(112 48 160)" }} />
                          ) : (
                            <ThumbDownAlt sx={{ color: "rgb(112 48 160)" }} />
                          )}
                        </IconButton>

                      </>
                    ) : (<></>)}
                  </CardContent>
                </Card>
              );
            })}
          </CardContent>
        </Card>
        <Button variant="contained" color="primary" sx={{ mt: 4, mb: 4 }} onClick={handleNext}>
          {nextStepLabel}
        </Button>
      </motion.div>
    </Container>
  );
}